<label from="billingCompany">Empresa</label>
<p-dropdown
  [options]="billingCompanyOptions"
  name="billingCompany"
  appendTo="body"
  (onChange)="change($event)">
</p-dropdown>
